import React, { useEffect, useState } from "react";
import noimage from "../../Assets/noimage.jpg";
import { useNavigate } from "react-router-dom"; // at the top
import {
  Modal,
  Box,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import { IoClose } from "react-icons/io5";
import { APIUrl, APIUrlToken, getIsUser } from "../../Utils/Utils";
import axios from "axios";
import { toast } from "react-toastify";
import { FaHeart } from "react-icons/fa";
import Loader from "../../Components/Loader/Loader";
import { NilCollaborationForm } from "../../Components/NilCollaborationForm/NilCollaborationForm";

const FavoriteCards = ({
  handleViewDetail,
  playersCount,
  loading,
  players,
  listFavoritePlayers,
  handleNextClick,
  open,
  setOpen,
  activePricingTab,
  setActivePricingTab,
}) => {
  const userLoginDetails = getIsUser();
  const navigate = useNavigate(); //
  const [formData, setFormData] = useState({
    player_id: 0,
    playerName: "",
    donateAmount: 0,
    teamName: "",
    transferredFrom: 0,
    transferedTeamName: "",
    transferredTo: 0,
    paymentDetails: "",
  });
  const [serviceType] = useState("general_contribution");
  const [openRequest, setOpenRequest] = useState();
  const [openSection, setOpenSection] = useState("one-time");
  const [oneTimeAmount, setOneTimeAmount] = useState(0);
  const [oneTimeOther, setOneTimeOther] = useState("");
  const [recurringAmount, setRecurringAmount] = useState(0);
  const [recurringOther, setRecurringOther] = useState("");
  const [selectedDuration, setSelectedDuration] = useState(3);
  const mode = activePricingTab === "fan" ? "contribute" : "collab";

  const durations = [
    { label: "3 Months", value: 3 },
    { label: "6 Months", value: 6 },
    { label: "12 Months", value: 12 },
  ];

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? "" : section);
  };

  const handleOpenModal = (player) => {
    setFormData({
      ...formData,
      player_id: player.player_id,
      playerName: player.player_name,
      teamName: player.team_name,
      transferredFrom: player?.team_id,
    });
    setOpen(true);
  };

  const handleOpenModalRequest = (player) => {
    setOpenRequest(player);
  };

  const handleDonationOnetime = () => {
    if (!oneTimeAmount) {
      toast.error("Please select or add donation amount.");
      return;
    }
    let data = {
      amount: Number(oneTimeAmount),
      nil_service_type: serviceType,
      player_id: Number(formData?.player_id),
      player_name: formData?.playerName,
      team_id: Number(formData.transferredFrom),
    };
    if (userLoginDetails?.user_id) {
      data.user_id = userLoginDetails?.user_id;
      data.user_email = userLoginDetails?.user_email;
    }

    axios({
      method: "POST",
      headers: { "X-API-Key": APIUrlToken() },
      data,
      url: `${APIUrl()}/v1/create-checkout-session/one_time`,
    })
      .then((response) => {
        const data = response?.data?.checkout_url || [];
        window.open(data, "_blank");
      })
      .catch((error) => {
        console.error("Error in one-time donation:", error);
      });
  };

  const handleDonationRecurring = () => {
    if (!recurringAmount) {
      toast.error("Please select or add donation amount.");
      return;
    }
    let data = {
      amount: Number(recurringAmount),
      nil_service_type: serviceType,
      player_id: Number(formData?.player_id),
      player_name: formData?.playerName,
      team_id: Number(formData.transferredFrom),
      recurring_cost_duration: Number(selectedDuration),
    };
    if (userLoginDetails?.user_id) {
      data.user_id = userLoginDetails?.user_id;
      data.user_email = userLoginDetails?.user_email;
    }

    axios({
      method: "POST",
      headers: { "X-API-Key": APIUrlToken() },
      data,
      url: `${APIUrl()}/v1/create-checkout-session/subscription`,
    })
      .then((response) => {
        const data = response?.data?.checkout_url || [];
        window.open(data, "_blank");
      })
      .catch((error) => {
        console.error("Error in recurring donation:", error);
      });
  };

  const saveUnFavoritePlayer = (player) => {
    if (!userLoginDetails) {
      toast.error("Please sign-up for a free account to access this feature");
      return;
    }
    const id = players?.find((item) => item?.player_id === player?.player_id);
    axios({
      method: "POST",
      headers: { "X-API-Key": APIUrlToken() },
      url: `${APIUrl()}/v1/v1/remove_favourite_player?id=${id?.favourites_id}`,
    })
      .then(() => {
        toast.success("Player removed from Favorites");
        listFavoritePlayers(true);
      })
      .catch((error) => {
        console.error("Error removing favorite:", error);
      });
  };
  const handleViewFanEngagement = (player) => {
    const url = `/FanExperience/${player.player_id}/${player.team_id}?mode=${mode}`;
    window.open(url, "_blank");
  };
  const handleViewBrandEngagement = (player) => {
    const url = `/BrandPartnership/${player.player_id}/${player.team_id}?mode=${mode}`;
    window.open(url, "_blank");
  };

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="main-filter-favoredsCards">
        <div className="pricing-sub-tabs">
          <div
            className={`pricing-sub-tab ${
              activePricingTab === "fan" ? "active" : ""
            }`}
            onClick={() => setActivePricingTab("fan")}
          >
            Your Fan Favorite Athletes
          </div>
          <div
            className={`pricing-sub-tab ${
              activePricingTab === "brand" ? "active" : ""
            }`}
            onClick={() => setActivePricingTab("brand")}
          >
            Your Brand Favorite Athletes
          </div>
        </div>

        {activePricingTab === "fan" ? (
          <div>
            {players?.length ? (
              <div className="card-outer-Container-fav">
                <div className="card-inner-Container">
                  {players
                    .sort((a, b) => b.received_donations - a.received_donations)
                    .map((player, index) => (
                      <div className="cards-box-dash" key={index}>
                        <div className="product-image">
                          <span
                            className="fa-nil-red"
                            onClick={() => saveUnFavoritePlayer(player)}
                          >
                            <FaHeart className="fa-red" />
                          </span>
                          <img
                            src={player?.image_url || noimage}
                            alt="Business"
                            onError={(e) => {
                              e.target.src = noimage;
                            }}
                          />
                        </div>
                        <div className="title-cards">
                          <h5>{player?.player_name}</h5>
                        </div>
                        <div className="listingid-dash">
                          <b>Team:</b>
                          <p className="listingid-numbs">{player?.team_name}</p>
                        </div>
                        <div className="listingid-dash">
                          <b>Class:</b>
                          <p className="listingid-numbs">
                            {player?.player_class}
                          </p>
                        </div>
                        <div className="dis-height-weight">
                          <div className="listingid-dash">
                            <b>Position:</b>
                            <p className="listingid-numbs">
                              {player?.position} #{" "}
                              {Math.round(player?.jersey_number)}
                            </p>
                          </div>
                        </div>
                        <div className="dis-height-weight">
                          <div className="business-price-dash">
                            <b>Height:</b>
                            <p className="business-price-numbs">
                              {player?.height}
                            </p>
                          </div>
                          <div className="business-price-dash">
                            {player?.weight ? <b>Weight:</b> : null}
                            <p className="business-price-numbs">
                              {player?.weight}
                            </p>
                          </div>
                        </div>
                        {/* <div className="view-details-dash">
                          <b>View Details:</b>
                          <p
                            onClick={() =>
                              navigate(
                                `/DetailsView/${player.player_id}/${player.team_id}`
                              )
                            }
                          >
                            Click here
                          </p>
                        </div> */}
                        <div
                          className="find-partner-btn"
                          style={{ marginTop: "10px" }}
                        >
                          <button
                            onClick={() => handleViewFanEngagement(player)}
                            // onClick={() => navigate("/FanExperience")}
                          >
                            {" "}
                            Start Your Fan Experience
                          </button>{" "}
                        </div>
                        {/* <div className="find-partner-btn">
                          <button
                            className="btn-collab"
                            onClick={() => handleOpenModalRequest(player)}
                          >
                            NIL Collaboration Request
                          </button>
                          <button onClick={() => handleOpenModal(player)}>
                            Contribute Now
                          </button>
                        </div> */}
                      </div>
                    ))}
                </div>
              </div>
            ) : !loading && !players?.length ? (
              <div className="no_results">No Results found.</div>
            ) : null}
            {!loading && players?.length && players?.length >= 50 ? (
              <div className="prev-next-container">
                <p className="next-btn-dash" onClick={handleNextClick}>
                  Load More
                </p>
              </div>
            ) : null}
          </div>
        ) : (
          <div>
            {players?.length ? (
              <div className="card-outer-Container-fav">
                <div className="card-inner-Container">
                  {players
                    .sort((a, b) => b.received_donations - a.received_donations)
                    .map((player, index) => (
                      <div className="cards-box-dash" key={index}>
                        <div className="product-image">
                          <span
                            className="fa-nil-red"
                            onClick={() => saveUnFavoritePlayer(player)}
                          >
                            <FaHeart className="fa-red" />
                          </span>
                          <img
                            src={player?.image_url || noimage}
                            alt="Business"
                            onError={(e) => {
                              e.target.src = noimage;
                            }}
                          />
                        </div>
                        <div className="title-cards">
                          <h5>{player?.player_name}</h5>
                        </div>
                        <div className="listingid-dash">
                          <b>Team:</b>
                          <p className="listingid-numbs">{player?.team_name}</p>
                        </div>
                        <div className="listingid-dash">
                          <b>Class:</b>
                          <p className="listingid-numbs">
                            {player?.player_class}
                          </p>
                        </div>
                        <div className="dis-height-weight">
                          <div className="listingid-dash">
                            <b>Position:</b>
                            <p className="listingid-numbs">
                              {player?.position} #{" "}
                              {Math.round(player?.jersey_number)}
                            </p>
                          </div>
                        </div>
                        <div className="dis-height-weight">
                          <div className="business-price-dash">
                            <b>Height:</b>
                            <p className="business-price-numbs">
                              {player?.height}
                            </p>
                          </div>
                          <div className="business-price-dash">
                            {player?.weight ? <b>Weight:</b> : null}
                            <p className="business-price-numbs">
                              {player?.weight}
                            </p>
                          </div>
                        </div>
                        {/* <div className="view-details-dash">
                          <b>View Details:</b>
                          <p
                            onClick={() =>
                              navigate(
                                `/DetailsView/${player.player_id}/${player.team_id}`
                              )
                            }
                          >
                            Click here
                          </p>
                        </div> */}
                        <div
                          className="find-partner-btn"
                          style={{ marginTop: "10px" }}
                        >
                          <button
                            // onClick={() => navigate("/BrandPartnership")}
                            onClick={() => handleViewBrandEngagement(player)}
                          >
                            {" "}
                            Start Your Brand Partnership
                          </button>{" "}
                        </div>
                        {/* <div className="find-partner-btn">
                          <button
                            className="btn-collab"
                            onClick={() => handleOpenModalRequest(player)}
                          >
                            NIL Collaboration Request
                          </button>
                          <button onClick={() => handleOpenModal(player)}>
                            Contribute Now
                          </button>
                        </div> */}
                      </div>
                    ))}
                </div>
              </div>
            ) : !loading && !players?.length ? (
              <div className="no_results">No Results found.</div>
            ) : null}
            {!loading && players?.length && players?.length >= 50 ? (
              <div className="prev-next-container">
                <p className="next-btn-dash" onClick={handleNextClick}>
                  Load More
                </p>
              </div>
            ) : null}
          </div>
        )}
      </div>

      <Modal open={open} onClose={() => setOpen(false)}>
        <div className="modal-container">
          <Box
            sx={{
              width: 700,
              p: 3,
              bgcolor: "white",
              borderRadius: 2,
              position: "relative",
            }}
          >
            <IoClose
              className="close-icon"
              size={24}
              onClick={() => setOpen(false)}
              style={{
                position: "absolute",
                top: 10,
                right: 10,
                cursor: "pointer",
              }}
            />
            <h3>
              Contribution for{" "}
              <span className="color-dc">{formData.playerName}</span> (
              {formData.teamName})
            </h3>
            <div className="donation-container">
              <div className="accordion">
                <div
                  className="accordion-header"
                  onClick={() => toggleSection("one-time")}
                >
                  One-Time Contribution
                  <span>{openSection === "one-time" ? "▼" : "▶"}</span>
                </div>
                <div
                  className={`accordion-content ${
                    openSection === "one-time" ? "open" : ""
                  }`}
                >
                  <div className="donation-options">
                    {[10, 20, 50, 100, 500, 1000].map((val) => (
                      <button
                        key={val}
                        className={
                          oneTimeOther === String(val) ? "selected" : ""
                        }
                        onClick={() => {
                          setOneTimeAmount(val);
                          setOneTimeOther(String(val));
                        }}
                      >
                        ${val}
                      </button>
                    ))}
                    <button
                      className={oneTimeOther === "other" ? "selected" : ""}
                      onClick={() => {
                        setOneTimeOther("other");
                        setOneTimeAmount();
                      }}
                    >
                      Other
                    </button>
                    {oneTimeOther === "other" ? (
                      <TextField
                        label="Contribution Amount"
                        type="number"
                        fullWidth
                        margin="normal"
                        value={oneTimeAmount}
                        onChange={(e) =>
                          setOneTimeAmount(
                            Math.max(0, parseInt(e.target.value || 0))
                          )
                        }
                      />
                    ) : null}
                    <FormControl fullWidth margin="normal">
                      <InputLabel id="service-type-label">
                        NIL Service Type
                      </InputLabel>
                      <Select
                        labelId="service-type-label"
                        id="service-type"
                        value="general_contribution"
                        label="NIL Service Type"
                        disabled
                        IconComponent={() => null}
                      >
                        <MenuItem value="general_contribution">
                          General Contribution
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <button
                    className="donate-btn"
                    onClick={handleDonationOnetime}
                  >
                    Make One-Time Contribution
                  </button>
                </div>
              </div>

              <div className="accordion">
                <div
                  className="accordion-header"
                  onClick={() => toggleSection("recurring")}
                >
                  Recurring Contribution
                  <span>{openSection === "recurring" ? "▼" : "▶"}</span>
                </div>
                <div
                  className={`accordion-content ${
                    openSection === "recurring" ? "open" : ""
                  }`}
                >
                  <div className="donation-options">
                    {[10, 20, 50, 100, 500, 1000].map((val) => (
                      <button
                        key={val}
                        className={
                          recurringOther === String(val) ? "selected" : ""
                        }
                        onClick={() => {
                          setRecurringAmount(val);
                          setRecurringOther(String(val));
                        }}
                      >
                        ${val}
                      </button>
                    ))}
                    <button
                      className={recurringOther === "other" ? "selected" : ""}
                      onClick={() => {
                        setRecurringOther("other");
                        setRecurringAmount();
                      }}
                    >
                      Other
                    </button>
                    {recurringOther === "other" ? (
                      <TextField
                        label="Contribution Amount"
                        type="number"
                        fullWidth
                        margin="normal"
                        value={recurringAmount}
                        onChange={(e) =>
                          setRecurringAmount(
                            Math.max(0, parseInt(e.target.value || 0))
                          )
                        }
                      />
                    ) : null}
                    <FormControl fullWidth margin="normal">
                      <InputLabel id="service-type-label">
                        NIL Service Type
                      </InputLabel>
                      <Select
                        labelId="service-type-label"
                        id="service-type"
                        value="general_contribution"
                        label="NIL Service Type"
                        disabled
                        IconComponent={() => null}
                      >
                        <MenuItem value="general_contribution">
                          General Contribution
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className="duration-selector">
                    {durations.map(({ label, value }) => (
                      <label
                        key={value}
                        className={`custom-checkbox ${
                          selectedDuration === value ? "checked" : ""
                        }`}
                      >
                        <input
                          type="checkbox"
                          checked={selectedDuration === value}
                          onChange={() => setSelectedDuration(value)}
                        />
                        <span className="checkmark" />
                        {label}
                      </label>
                    ))}
                  </div>
                  <button
                    className="donate-btn"
                    onClick={handleDonationRecurring}
                  >
                    Make Recurring Contribution
                  </button>
                </div>
              </div>
            </div>
          </Box>
        </div>
      </Modal>

      <NilCollaborationForm
        openRequest={openRequest}
        setOpenRequest={setOpenRequest}
      />
    </>
  );
};

export default FavoriteCards;
